package uz.ferro.shop.manager

import uz.ferro.shop.api.suspendGet
import uz.ferro.shop.api.suspendPost
import uz.ferro.shop.api.suspendPut
import uz.ferro.shop.model.PickupPoint

object PickupPointManager {

    suspend fun getAdminPickupPoints(): List<PickupPoint> {
        return suspendGet("admin/pickup-point/list")
    }

    suspend fun getAdminPickupPoint(id: Long): PickupPoint {
        return suspendGet("admin/pickup-point/$id")
    }

    suspend fun savePickupPoint(pickupPoint: PickupPoint): PickupPoint {
        return if (pickupPoint.id != null) {
            suspendPut(path = "admin/pickup-point", body = pickupPoint)
        } else {
            suspendPost(path = "admin/pickup-point", body = pickupPoint)
        }
    }
}